<template>
    <!-- Стандартный отступ страницы -->
    <MainLayout>
        <!-- Сетка кнопок-ячеек -->
        <div class="cells-grid">
            <div class="cell cell-drops" @click="goToDropManagement">
                <div class="cell-glow"></div>
                <div class="cell-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                </div>
                <div class="cell-label">Дропы</div>
            </div>

            <div class="cell cell-stock" @click="goToPresencetManagement">
                <div class="cell-glow"></div>
                <div class="cell-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                        <line x1="12" y1="22.08" x2="12" y2="12"></line>
                    </svg>
                </div>
                <div class="cell-label">Наличие</div>
            </div>

            <div class="cell cell-bot" @click="goToBotSettings">
                <div class="cell-glow"></div>
                <div class="cell-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <rect x="3" y="11" width="18" height="10" rx="2"></rect>
                        <circle cx="12" cy="5" r="2"></circle>
                        <path d="M12 7v4"></path>
                        <line x1="8" y1="16" x2="8" y2="16"></line>
                        <line x1="16" y1="16" x2="16" y2="16"></line>
                    </svg>
                </div>
                <div class="cell-label">Бот</div>
            </div>

            <div class="cell cell-sale" @click="isAddSaleModalOpen=true">
                <div class="cell-glow"></div>
                <div class="cell-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </div>
                <div class="cell-label">Продажа</div>
            </div>
        </div>

        <!-- Кнопка генерации PDF под ячейками -->
        <button 
            class="pdf-button" 
            @click="generatePdf" 
            :disabled="isGeneratingPdf"
            :class="{ 'loading': isGeneratingPdf, 'success': pdfSuccess }"
        >
            <div class="pdf-button-content">
                <div class="pdf-icon" v-if="!isGeneratingPdf && !pdfSuccess">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                </div>
                <div class="pdf-icon spinner" v-else-if="isGeneratingPdf">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-dashoffset="20"></circle>
                    </svg>
                </div>
                <div class="pdf-icon success-icon" v-else>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
                <span class="pdf-label">{{ pdfButtonText }}</span>
            </div>
            <div class="pdf-glow"></div>
        </button>

        <!-- Компонент поиска по номеру заказа -->
        <SearchOrderComponent 
            class="search-component"
            @order-updated="handleOrderUpdated"
        />

        <!-- Модальное окно -->
        <div class="modal-overlay" v-if="isAddSaleModalOpen" @click="closeModal">
            <div class="modal-content" @click.stop>
                <AddSaleComponent @close="closeModal" />
            </div>
        </div>

        <!-- Блок сортировки заказов -->
        <SortComponent @filters-change="handleFiltersChange" :admin_sort="true"/>

        <!-- Блок отображения заказов -->
        <OrdersComponent 
            ref="ordersList"
            :filters="activeFilters" 
            :admin_orders="true"
            @order-updated="handleOrderUpdated"
        />
        
        <!-- Меню с личным кабинетом для дропов -->
        <DropMenu style="position: fixed; bottom: 20px; right: 0px;"/>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue';
import DropMenu from '@/components/DropMenu.vue';
import AddSaleComponent from '@/components/AddSaleComponent.vue';
import SortComponent from '@/components/SortComponent.vue';
import OrdersComponent from '@/components/DropOrdersCardComponent.vue';
import SearchOrderComponent from '@/components/SearchOrderComponent.vue';
import api from '@/api/api';

export default{
    name: 'DropManagerPage',
    components: {
        MainLayout,
        DropMenu,
        AddSaleComponent,
        SortComponent,
        OrdersComponent,
        SearchOrderComponent,
    },
    data() {
        return {
            isAddSaleModalOpen: false,
            activeFilters: {},
            isGeneratingPdf: false,
            pdfSuccess: false,
            pdfMessage: '',
        }
    },
    computed: {
        pdfButtonText() {
            if (this.isGeneratingPdf) return 'Генерация...';
            if (this.pdfSuccess) return 'Отправлено в Telegram';
            return 'Сгенерировать PDF ярлыки';
        }
    },
    methods: {
        closeModal() {
            this.isAddSaleModalOpen = false;
        },
        goToDropManagement() {
            this.$router.push('/drop-management');
        },
        goToPresencetManagement() {
            this.$router.push('/presence-management');
        },
        goToBotSettings() {
            this.$router.push('/bot-settings');
        },
        
        // Генерация PDF через API
        async generatePdf() {
            if (this.isGeneratingPdf) return;
            
            this.isGeneratingPdf = true;
            this.pdfSuccess = false;
            
            try {
                const response = await api.get('/manager/generate-pdf');
                
                this.pdfSuccess = true;
                this.pdfMessage = response.data.message;
                
                // Сброс success состояния через 3 секунды
                setTimeout(() => {
                    this.pdfSuccess = false;
                }, 3000);
                
            } catch (error) {
                console.error('Ошибка при генерации PDF:', error);
                
                let errorMessage = 'Ошибка при генерации PDF';
                if (error.response?.status === 404) {
                    errorMessage = 'Нет заказов в статусе ожидания отправки';
                } else if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail;
                }
                
                alert(errorMessage);
            } finally {
                this.isGeneratingPdf = false;
            }
        },

        handleFiltersChange(filters) {
            this.activeFilters = { ...filters };
        },

        handleOrderUpdated() {
            if (this.$refs.ordersList) {
                this.$refs.ordersList.resetAndLoad();
            }
        }
    }
}
</script>

<style scoped>
/* Сетка ячеек */
.cells-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 3vw;
    margin-bottom: 3vw;
}

/* Базовая ячейка */
.cell {
    aspect-ratio: 1;
    border-radius: 16px;
    backdrop-filter: blur(20px) saturate(1.5);
    -webkit-backdrop-filter: blur(20px) saturate(1.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 
        0 4px 24px rgba(0, 0, 0, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

/* Свечение под иконкой */
.cell-glow {
    position: absolute;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    filter: blur(25px);
    opacity: 0.3;
    transition: all 0.3s ease;
}

/* Иконка */
.cell-icon {
    width: 24px;
    height: 24px;
    color: rgba(255, 255, 255, 0.9);
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
}

.cell-icon svg {
    width: 100%;
    height: 100%;
}

/* Подпись */
.cell-label {
    font-size: 10px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    letter-spacing: 0.4px;
    font-family: 'CentureGothic', sans-serif;
    position: relative;
    z-index: 2;
    transition: color 0.3s ease;
}

/* Hover эффекты ячеек */
.cell:hover {
    transform: translateY(-3px);
    border-color: rgba(255, 255, 255, 0.15);
    box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.cell:hover .cell-glow {
    opacity: 0.5;
    transform: scale(1.3);
}

.cell:hover .cell-icon {
    color: rgba(255, 255, 255, 1);
    transform: translateY(-2px);
}

.cell:hover .cell-label {
    color: rgba(255, 255, 255, 0.95);
}

.cell:active {
    transform: scale(0.96);
}

/* === НЕЙТРАЛЬНАЯ ТЁМНАЯ ПАЛИТРА ЯЧЕЕК === */

/* Дропы — графитовый */
.cell-drops {
    background: linear-gradient(145deg, rgba(45, 45, 50, 0.6) 0%, rgba(30, 30, 35, 0.5) 100%);
}
.cell-drops .cell-glow {
    background: radial-gradient(circle, rgba(120, 120, 130, 0.6) 0%, transparent 70%);
}

/* Наличие — стальной */
.cell-stock {
    background: linear-gradient(145deg, rgba(50, 55, 60, 0.6) 0%, rgba(35, 40, 45, 0.5) 100%);
}
.cell-stock .cell-glow {
    background: radial-gradient(circle, rgba(140, 150, 160, 0.6) 0%, transparent 70%);
}

/* Бот — угольный */
.cell-bot {
    background: linear-gradient(145deg, rgba(40, 42, 48, 0.6) 0%, rgba(25, 27, 32, 0.5) 100%);
}
.cell-bot .cell-glow {
    background: radial-gradient(circle, rgba(100, 110, 130, 0.6) 0%, transparent 70%);
}

/* Продажа — антрацитовый с акцентом */
.cell-sale {
    background: linear-gradient(145deg, rgba(55, 55, 60, 0.7) 0%, rgba(40, 40, 45, 0.6) 100%);
    border-color: rgba(255, 255, 255, 0.12);
}
.cell-sale .cell-glow {
    background: radial-gradient(circle, rgba(180, 180, 190, 0.5) 0%, transparent 70%);
}
.cell-sale .cell-icon {
    color: rgba(255, 255, 255, 0.95);
}

/* === КНОПКА PDF === */
.pdf-button {
    width: 100%;
    height: 14vw;
    max-height: 56px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(145deg, rgba(60, 60, 65, 0.5) 0%, rgba(40, 40, 45, 0.4) 100%);
    backdrop-filter: blur(20px) saturate(1.5);
    -webkit-backdrop-filter: blur(20px) saturate(1.5);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-bottom: 3vw;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 
        0 4px 24px rgba(0, 0, 0, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.pdf-button:hover:not(:disabled) {
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.15);
    box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.pdf-button:active:not(:disabled) {
    transform: scale(0.98);
}

.pdf-button:disabled {
    cursor: not-allowed;
    opacity: 0.8;
}

/* Успешное состояние */
.pdf-button.success {
    background: linear-gradient(145deg, rgba(60, 100, 60, 0.5) 0%, rgba(40, 80, 40, 0.4) 100%);
    border-color: rgba(100, 200, 100, 0.3);
}

.pdf-button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
    z-index: 2;
}

.pdf-icon {
    width: 20px;
    height: 20px;
    color: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease;
}

.pdf-icon svg {
    width: 100%;
    height: 100%;
}

.pdf-icon.spinner {
    animation: spin 1s linear infinite;
}

.success-icon {
    color: rgba(150, 255, 150, 0.9);
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.pdf-label {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    font-family: 'CentureGothic', sans-serif;
    letter-spacing: 0.3px;
}

.pdf-button.success .pdf-label {
    color: rgba(150, 255, 150, 0.95);
}

/* Свечение кнопки */
.pdf-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 80%;
    background: radial-gradient(circle, rgba(150, 150, 160, 0.15) 0%, transparent 70%);
    filter: blur(20px);
    opacity: 0.5;
    transition: opacity 0.3s ease;
}

.pdf-button:hover .pdf-glow {
    opacity: 0.8;
}

.pdf-button.success .pdf-glow {
    background: radial-gradient(circle, rgba(100, 200, 100, 0.2) 0%, transparent 70%);
}

/* Стиль для компонента поиска */
.search-component {
    margin-bottom: 3vw;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px 0;
}

.modal-content {
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  margin: auto;
}

/* Адаптив */
@media (max-width: 380px) {
    .cells-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 4vw;
    }
    
    .cell-icon {
        width: 28px;
        height: 28px;
    }
    
    .cell-label {
        font-size: 11px;
    }
    
    .pdf-button {
        height: 16vw;
    }
    
    .pdf-label {
        font-size: 12px;
    }
}
</style>